import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import sampleData from "../../data/samplePosts.json"; // 임시 JSON 데이터

function RecentBoardsCard({
  codeId,
  title = "최근 게시물",
  headers = ["제목", "작성자", "작성일"],
  rowKeys = ["title", "writer_name", "created_at"],
  limit = 5,
  dataSource = "api", // "api" | "json"
  fetchFn, // API 호출 함수 (dataSource="api"일 때만 필요)
}) {
  const [posts, setPosts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRecentPosts = async () => {
      try {
        if (dataSource === "api" && fetchFn) {
          const { posts: fetchedPosts } = await fetchFn(1, limit, "", codeId);
          setPosts(fetchedPosts);
        } else if (dataSource === "json") {
          const filtered = sampleData.filter((post) => post.code_id === codeId);
          setPosts(filtered.slice(0, limit));
        }
      } catch (error) {
        console.error("게시물 불러오기 실패:", error);
      }
    };
    fetchRecentPosts();
  }, [codeId, dataSource, limit, fetchFn]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().slice(0, 10);
  };

  return (
    <div className="card mb-3 flex-grow-1">
      <div className="card-body">
        {/* 헤더 영역 */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">{title}</h4>
          {dataSource === "api" ? (
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => navigate(`/board?page=1&code_id=${codeId}`)}
            >
              더보기
            </button>
          ) : (
            <button className="btn btn-outline-secondary btn-sm" disabled>
              더보기
            </button>
          )}
        </div>

        {/* 게시물 목록 */}
        {posts.length === 0 ? (
          <p className="text-muted text-center">게시물이 없습니다.</p>
        ) : (
          <div className="table-responsive">
            <table 
              className="table align-middle table-hover mb-0"
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <thead className="table-light">
                <tr>
                  {headers.map((h, idx) => (
                    <th
                      key={idx}
                      className={idx === 0 ? "" : "text-center"}
                      style={{ width: idx === 0 ? "auto" : (idx === 1 ? "80px" : "100px") }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {posts.slice(0, limit).map((post) => (
                  <tr
                    key={post.id}
                    style={{ cursor: dataSource === "api" ? "pointer" : "default" }}
                    onClick={() =>
                      dataSource === "api" &&
                      navigate(`/post/${post.id}?page=1&code_id=${codeId}`)
                    }
                  >
                    {rowKeys.map((key, idx) => (
                      <td 
                        key={idx} 
                        className={idx === 0 ? "" : "text-center"}
                        style={{
                          overflow: 'hidden',
                          textOverflow: idx === 0 ? 'ellipsis' : 'clip',
                          whiteSpace: 'nowrap'
                        }}
                      >
                        {key.includes("date") || key.includes("at")
                          ? formatDate(post[key])
                          : post[key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default RecentBoardsCard;